import caES from 'dayjs/locale/ca';
import deDe from 'dayjs/locale/de';
// en-ca is identical to en-us. But the exported dayjs/locale/en cannot be used for dayjs.locale('en-US', enUS); call.
import enUS from 'dayjs/locale/en-ca';
import esES from 'dayjs/locale/es';
import esUS from 'dayjs/locale/es-us';
import frCA from 'dayjs/locale/fr-ca';
import itIT from 'dayjs/locale/it';
import nlNL from 'dayjs/locale/nl';
import slSI from 'dayjs/locale/sl';
import urPK from 'dayjs/locale/ur';

import faIR from './fa-ir';
import zuZU from './zu-zu';

export const Locales = [
    ['de-DE', deDe],
    ['es-ES', esES],
    ['ca-ES', caES],
    ['sl-SI', slSI],
    ['es-US', esUS],
    ['es-CO', esUS],
    ['fa-IR', faIR],
    ['fr-CA', frCA],
    ['it-IT', itIT],
    ['nl-NL', nlNL],
    ['ur-PK', urPK],
    ['en-US', enUS],
    ['zu-ZU', zuZU],
] as const;
